import * as yup from "yup";

const modelValidation = yup.object().shape({
  name: yup.string().required("Bu alan zorunludur"),
});

export default modelValidation;
